// extracted by mini-css-extract-plugin
export default {"wrap":"PeriodComponent_wrap__6FEal","daysCount":"PeriodComponent_daysCount__IUmYJ","discount":"PeriodComponent_discount__z7i0c","btn":"PeriodComponent_btn__xyZSG"};